/**
 * Component: NotFound
 */
const NotFound = () => <div className="col-span-full justify-self-center text-center text-xl">❌ Nincs találat ❌</div>;
export default NotFound;
